import localeEN from "../locales/en.json"
import localeJA from "../locales/ja.json"
export const locales = {
    en: localeEN,
    ja: localeJA
}
